import { render, staticRenderFns } from "./ManageClass.vue?vue&type=template&id=07233778"
import script from "./ManageClass.vue?vue&type=script&lang=js"
export * from "./ManageClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports